/* Default: page content participates in mainInner scroll (AppShellLayout.module.css). */

.scroll {

  flex: 0 0 auto;

  width: 100%;

  min-width: 0;

}



/* Workspace: fill the mainInner viewport; only nested tables/panels scroll. */

.workspace {

  flex: 1 1 auto;

  min-height: 0;

  overflow: hidden;

  display: flex;

  flex-direction: column;

  width: 100%;

}



.workspace > :global([data-testid='page-header']) {

  flex-shrink: 0;

}


